import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalDocument } from 'lavva.exalushome/build/js/Services/SupportedDevices/ISupportedDevicesService';
import { Grid, useMediaQuery } from '@mui/material';
import { IconWarning } from '../../../../../../assets/icons/icon-warning';
import { CircularProgress, DialogConfirmation, EmptyStateBox, Header, NavHeader } from '../../../../../../components';
import ArrowButton from '../../../../../../components/arrow-button';
import { Page } from '../../../../../../components/page';
import { useSupportedDevices } from '../../../../../../hooks/supported-devices/use-supported-devices';
import { DashboardResourceItem, ObjectFitType } from '../../components/dashboard-resource-item/dashboard-resource-item';
import { DialogInstructionsData } from '../../types/types';

const Instructions: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { t: tc } = useTranslation('common');
  const [dialogData, setDialogData] = useState<DialogInstructionsData | null>(null);
  const { data, isLoading } = useSupportedDevices();
  const isSmall = useMediaQuery('(max-width:430px)');

  const handleRedirect = (url: string) => window.open(url, '_blank');

  const handleOpenInstructions = (deviceName: string, documents: ExternalDocument[]) => {
    setDialogData({ deviceName, documents });
  };

  const handleCloseDialog = () => setDialogData(null);

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height p-t-0"
      header={
        <>
          <NavHeader />
          <Header title={t('resources.instructions.title')} isUnderline />
        </>
      }
    >
      <Grid container spacing={2}>
        {isLoading ? (
          <CircularProgress />
        ) : data?.length ? (
          (data || []).map((x, index) => (
            <Grid key={index} size={{ xs: isSmall ? 12 : 6, sm: 6, md: 4 }}>
              <DashboardResourceItem
                title={x.Name}
                subTitle={t('resources.instructions.title')}
                onClick={() => handleOpenInstructions(x.Name, x.ManualsAndDocuments)}
                imagePath={x.Pictures.length ? x.Pictures[0] : ''}
                objectFit={ObjectFitType.Contain}
                fullWidth
                whiteImageBackground
              />
            </Grid>
          ))
        ) : (
          <EmptyStateBox content={t('resources.instructions.notFound')} icon={<IconWarning />} />
        )}
      </Grid>
      <DialogConfirmation
        show={dialogData !== null}
        setShow={handleCloseDialog}
        header={`${t('resources.instructions.title')} ${dialogData?.deviceName || ''}`}
        secondaryBtnText={tc('buttons.cancel')}
        secondaryBtnAction={handleCloseDialog}
      >
        {dialogData?.documents.map((doc) => (
          <ArrowButton
            key={doc.Id}
            title={doc.Title}
            onClick={() => handleRedirect(doc.Link)}
            className="m-b-16"
            dark
          />
        ))}
      </DialogConfirmation>
    </Page>
  );
};

export default Instructions;
